var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"app":"","color":"#1976D2","dark":""}},[_c('v-app-bar-nav-icon',{on:{"click":_vm.toggleNavigationBar}}),_c('v-toolbar-title'),_c('div',{staticClass:"flex-grow-1"}),_c('h3',[_vm._v("Usuario: "+_vm._s(_vm.nameUser))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }